<template>
    <FormulateInput
      v-bind="$attrs"
      v-on="$listeners"
      :type="type"
      :name="name"
      :label="label"
      :help="help"
      :placeholder="placeholder"
      :validation="validation"
      :error-behavior="errorBehavior"
      :value="value"
    />
  </template>

<script>

export default {
  name: 'NxInput',
  props: {
    type: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    label: {
      type: String,
      default: ''
    },
    help: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    validation: {
      type: [String, Object],
      default: ''
    },
    errorBehavior: {
      type: String,
      default: 'blur'
    },
    value: {
      type: [String, Number, Boolean, Array, Object, File, Date],
      default: null
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/forms/inputs/NxInput.vue